import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "tag text-truncate" }

import CloseIcon from "~/chat/vue/misc/CloseIcon.vue";


const __default__ = {
    name: "ChatTag"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  emits: ["close"],
  setup(__props, { emit: __emit }) {

let emits = __emit;

return (_ctx: any,_cache: any) => {
  const _directive_on_native = _resolveDirective("on-native")!

  return (_openBlock(), _createElementBlock("span", _hoisted_1, [
    _renderSlot(_ctx.$slots, "default"),
    _withDirectives(_createVNode(CloseIcon, { class: "close" }, null, 512), [
      [_directive_on_native, () => _unref(emits)('close'), "click"]
    ])
  ]))
}
}

})